export default __webpack_public_path__ + "static/media/bihada-factory-profile-nidoru.89d41708.png";